import { BREAKPOINT_MEDIA_QUERIES } from '../utils/breakpoints';
import { defineModule } from '../utils/helpers';

/**
 * Keeps a legal page's table of contents open on the wide layout.
 *
 * The list is a `<details>` so it can collapse on mobile, and it ships open, so
 * the desktop layout is already right without JavaScript. CSS stops the mouse
 * from closing it there, but a keyboard user can still hit Enter on the
 * summary — and a mobile visitor who closed it and then rotated to a wide
 * viewport would be left with an empty sidebar. Both are handled here.
 */
const getElements = () => ({
  detailsElements: document.querySelectorAll<HTMLDetailsElement>(
    '.policy-toc__details',
  ),
});

const isWideLayout = () => BREAKPOINT_MEDIA_QUERIES.lg.matches;

const openOnWideLayout = () => {
  if (!isWideLayout()) return;

  getElements().detailsElements.forEach((details) => {
    if (!details.open) details.open = true;
  });
};

const onToggle = (e: Event) => {
  const details = e.target;
  if (!(details instanceof HTMLDetailsElement) || details.open) return;

  openOnWideLayout();
};

export default defineModule(
  () => {
    openOnWideLayout();

    BREAKPOINT_MEDIA_QUERIES.lg.addEventListener('change', openOnWideLayout);
    getElements().detailsElements.forEach((details) =>
      details.addEventListener('toggle', onToggle),
    );
  },
  () => {
    BREAKPOINT_MEDIA_QUERIES.lg.removeEventListener('change', openOnWideLayout);
    getElements().detailsElements.forEach((details) =>
      details.removeEventListener('toggle', onToggle),
    );
  },
);
